// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import Menu from 'components/menu/menu'

// const logoTextSVG = siteData.images_url + 'logo/adventist_church_in_nzpuc_text_horizontal_white.svg?v=2'
// const logoTextPNG = siteData.images_url + 'logo/adventist_church_in_nzpuc_text_horizontal_white.png?v=2'

const logoTextSVG = siteData.images_url + 'logo/disciple-white.svg?v=2'
const logoTextPNG = siteData.images_url + ''

const siteName = siteData.site_name
const siteURL = siteData.site_url
const siteImage = siteData.featured_image_url
const siteImageSrcset = siteData.featured_image_srcset

class HeaderPrimary extends React.Component {
	render() {
		const { locale, hasMultipleLocales } = this.props
		const homeUrl = hasMultipleLocales ? `/${locale}/` : '/'

		return (
			<header className="header">
				<div className="header-top">
					<div className="logo">
						<Link to={ homeUrl }>
							<img className="site-logo" src={ logoTextSVG } data-fallback={ logoTextPNG } alt="" />
						</Link>
					</div>
				</div>

				<Menu />
			</header>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		locale: state.site.locale,
		hasMultipleLocales: state.site.hasMultipleLocales
	}
}

export default connect( mapStateToProps )( HeaderPrimary )



// WEBPACK FOOTER //
// ./components/HeaderPrimary/HeaderPrimary.jsx